import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { AddFirmwareState } from './useAddFirmware';

/** The image upload and what the backend read from it. */
export const FirmwareUploadSection: React.FC<{ state: AddFirmwareState }> = ({ state }) => {
  const { t } = useI18n();
  const { uploadResult } = state;

  const facts: Array<[string, string]> = uploadResult ? [
    [t('otaUpdates.validEsp32'), uploadResult.is_valid_esp32 ? t('common.yes') : t('common.no')],
    [t('otaUpdates.appVersion'), uploadResult.app_version || '-'],
    [t('otaUpdates.project'), uploadResult.project_name || '-'],
    [t('otaUpdates.idfVersion'), uploadResult.idf_version || '-'],
    [t('otaUpdates.compileDate'), uploadResult.compile_date || '-'],
    [t('otaUpdates.compileTime'), uploadResult.compile_time || '-'],
    [t('otaUpdates.flashMode'), uploadResult.flash_mode],
    [t('otaUpdates.fileSize'), `${(uploadResult.file_size / 1024 / 1024).toFixed(2)} MB`],
  ] : [];

  return (
    <div className="device-section">
      <h3 className="section-title">{t('otaUpdates.uploadFirmwareFile')}</h3>
      <div className="firmware-upload-area">
        <input
          type="file"
          data-testid="field-firmware-file"
          accept=".bin"
          onChange={(e) => e.target.files?.[0] && state.upload(e.target.files[0])}
          disabled={state.submitting || state.uploading}
          className="file-input"
        />
        {state.uploading && <p className="upload-status">{t('otaUpdates.uploading')}</p>}
      </div>

      {uploadResult && (
        <div className="firmware-analysis-result">
          <h4 className="analysis-title">{t('otaUpdates.extractedFirmwareDetails')}</h4>
          <div className="analysis-grid">
            {facts.map(([label, value]) => (
              <div className="analysis-item" key={label}>
                <span className="analysis-label">{label}</span>
                <span className="analysis-value">{value}</span>
              </div>
            ))}
          </div>
          <div className="analysis-item analysis-sha256">
            <span className="analysis-label">SHA256</span>
            <span className="analysis-value">{uploadResult.file_sha256}</span>
          </div>
        </div>
      )}
    </div>
  );
};
